import one from 'assets/gallery/01.jpg';
import two from 'assets/gallery/02.jpg';
import three from 'assets/gallery/03.jpg';
import four from 'assets/gallery/04.jpg';
import five from 'assets/gallery/05.jpg';
import six from 'assets/gallery/06.jpg';
import seven from 'assets/gallery/07.jpg';

export const images = [one, two, three, four, five, six, seven];
